module.exports = __webpack_public_path__ + "img/img_userCase5.065c45d8.png";